// Registriert alle Bausteine aus src/components/ui global (Seiten importieren sie nicht einzeln) und stellt den
// Shell-Zustand als this.$shell bereit (Spezifikation 2.1).
import { shell } from '../shell/shellState';
import AppIcon from '../components/ui/AppIcon.vue';
import AppButton from '../components/ui/AppButton.vue';
import AppIconButton from '../components/ui/AppIconButton.vue';
import AppTextField from '../components/ui/AppTextField.vue';
import AppSearch from '../components/ui/AppSearch.vue';
import AppSelect from '../components/ui/AppSelect.vue';
import AppMonthStepper from '../components/ui/AppMonthStepper.vue';
import AppSegment from '../components/ui/AppSegment.vue';
import AppCheckbox from '../components/ui/AppCheckbox.vue';
import AppSwitchRow from '../components/ui/AppSwitchRow.vue';
import AppTag from '../components/ui/AppTag.vue';
import AppAvatar from '../components/ui/AppAvatar.vue';
import AppDialog from '../components/ui/AppDialog.vue';
import AppPage from '../components/ui/AppPage.vue';
import AppPanel from '../components/ui/AppPanel.vue';
import AppKpiTile from '../components/ui/AppKpiTile.vue';
import AppMiniBars from '../components/ui/AppMiniBars.vue';
import AppShareBar from '../components/ui/AppShareBar.vue';
import AppDetailPane from '../components/ui/AppDetailPane.vue';
import AppGridFooter from '../components/ui/AppGridFooter.vue';
import AppSaveBar from '../components/ui/AppSaveBar.vue';
import AppStateOverlay from '../components/ui/AppStateOverlay.vue';
import AppToast from '../components/ui/AppToast.vue';

const components = {
  AppIcon,
  AppButton,
  AppIconButton,
  AppTextField,
  AppSearch,
  AppSelect,
  AppMonthStepper,
  AppSegment,
  AppCheckbox,
  AppSwitchRow,
  AppTag,
  AppAvatar,
  AppDialog,
  AppPage,
  AppPanel,
  AppKpiTile,
  AppMiniBars,
  AppShareBar,
  AppDetailPane,
  AppGridFooter,
  AppSaveBar,
  AppStateOverlay,
  AppToast
};

export default {
  install(Vue) {
    Object.keys(components).forEach((name) => {
      Vue.component(name, components[name]);
    });
    Vue.prototype.$shell = shell;
  }
};
